import { render } from "./change-login-url.vue?vue&type=template&id=7ca6b090"
import script from "./change-login-url.vue?vue&type=script&lang=js"
export * from "./change-login-url.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__